import { GlobalToken } from 'antd/es/theme/interface'
import { ValidationResult } from '../../cell-validators'
import Shipment from '../../../types/api/shipment'
import { getShipmentDisplayCalculated } from '../shipment/get-shipment-display-calculated'
import {
    getShipmentTotalReservedAmount,
    shouldValidateReserves,
} from './get-shipment-reserved-amount'

export interface MaterialValidationIssue {
    message: string
}

function getMaterialReserveIssue(shipment: Shipment): MaterialValidationIssue | null {
    const materialLength = getShipmentDisplayCalculated(shipment)?.materialLength

    if (materialLength === undefined || !shouldValidateReserves(shipment)) {
        return null
    }

    const totalReserved = getShipmentTotalReservedAmount(shipment)

    if (materialLength <= totalReserved) {
        return null
    }

    return {
        message: `Зарезервировано ${totalReserved.toFixed(2)} км, необходимо ${materialLength.toFixed(2)} км`,
    }
}

export function getMaterialValidationIssues(shipment: Shipment): MaterialValidationIssue[] {
    const reserveIssue = getMaterialReserveIssue(shipment)

    return reserveIssue ? [reserveIssue] : []
}

export function getMaterialValidationResult(
    shipment: Shipment | undefined | null,
    token: GlobalToken
): ValidationResult | null {
    if (!shipment) {
        return null
    }

    const issues = getMaterialValidationIssues(shipment)

    if (issues.length === 0) {
        return null
    }

    return {
        message: null,
        color: token.colorErrorText || token.colorError,
        bgColor: token.colorErrorBg,
    }
}
